import { TJobLedgerListItemDto } from "@/api/services/main/job-ledger/dtos/get-job-ledger-list.dto";
import { TJobLedgerRow } from "@/features/management-ledger/types/management-ledger";
import { ECaseMatchStatus } from "@/types/enum";
import { TOption } from "@/types/common";
import { findLabelByValue } from "@/utils/object";
import { dayjs } from "@/utils/dayjs";
const HIRED_STATUSES: ECaseMatchStatus[] = [ECaseMatchStatus.OFFER_ACCEPTED, ECaseMatchStatus.ALREADY_HIRED];
const REJECTED_STATUSES: ECaseMatchStatus[] = [
    ECaseMatchStatus.FAILED,
    ECaseMatchStatus.CANDIDATE_WITHDRAWN,
    ECaseMatchStatus.OFFER_CANCELLED,
    ECaseMatchStatus.SELECTION_CANCELLED,
];
const getHiringResult = (status: number | null): string => {
    if (status == null)
        return "";
    if (HIRED_STATUSES.includes(status))
        return "採用";
    if (REJECTED_STATUSES.includes(status))
        return "不採用";
    return "";
};
const JOB_NAME_MAX_LENGTH = 55;
const truncateJobName = (name: string | null): string => {
    const value = name ?? "";
    return value.length > JOB_NAME_MAX_LENGTH ? `${value.slice(0, JOB_NAME_MAX_LENGTH)}...` : value;
};
const formatDate = (date: string | null): string => (date ? dayjs(date).format("YYYY/MM/DD") : "");
const buildEmployerInfo = (dto: TJobLedgerListItemDto): string => {
    const fullAddress = `${dto.zipCode ?? ""}${dto.prefecture ?? ""}${dto.city ?? ""}${dto.address ?? ""}`;
    const contact = `${dto.contactPersonName ?? ""}${dto.contactPersonPhone ? `／${dto.contactPersonPhone}` : ""}`;
    return `①${dto.companyName ?? ""}\n②${fullAddress}\n③${contact}`;
};
const buildOccupation = (dto: TJobLedgerListItemDto): string => [dto.occupation, dto.businessCategory].filter(Boolean).join(" / ");
export const transformJobLedgerDtoToRow = (dto: TJobLedgerListItemDto, salaryTypeOptions: TOption[]): TJobLedgerRow => ({
    caseMatchId: dto.caseMatchId,
    jobId: dto.jobId,
    jobRowSpan: 1,
    jobManagementNo: dto.managementNumber ?? "",
    employerInfo: buildEmployerInfo(dto),
    receptionDate: formatDate(dto.startDate),
    validPeriod: formatDate(dto.endDate),
    openings: dto.recruitmentNumber != null ? String(dto.recruitmentNumber) : "",
    occupation: buildOccupation(dto),
    workplace: dto.workplace ?? "",
    employmentPeriod: dto.employmentPeriod ?? null,
    wage: findLabelByValue(salaryTypeOptions, dto.salaryType),
    jobName: truncateJobName(dto.jobName),
    referralDate: formatDate(dto.referralDate),
    jobseekerName: dto.jobseekerName ?? "",
    hiringResult: getHiringResult(dto.caseMatchStatus),
    hiredDate: formatDate(dto.hiredDate),
    referralEmploymentPeriod: dto.referralEmploymentPeriod ?? null,
    permanentEmploymentNote: dto.permanentEmploymentNote ?? "",
    separationStatusNote: dto.separationStatusNote ?? "",
    remarks: dto.remarks ?? "",
});
export const assignJobRowSpans = (rows: TJobLedgerRow[]): TJobLedgerRow[] => {
    let groupStart = 0;
    for (let i = 1; i <= rows.length; i++) {
        if (i === rows.length || rows[i].jobId !== rows[groupStart].jobId) {
            const span = i - groupStart;
            rows[groupStart].jobRowSpan = span;
            for (let j = groupStart + 1; j < i; j++)
                rows[j].jobRowSpan = 0;
            groupStart = i;
        }
    }
    return rows;
};
